import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import { Button } from '@mui/material'

interface ProofButtonProps {
  label: string
  onClick?: () => void
}

const proofButtonStyles = {
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
  color: '#414651',
  textTransform: 'none',
  py: 1.5,
  px: 4,
  fontWeight: 600,
  fontSize: '13.33px',
  lineHeight: '150%',
  letterSpacing: '0.15px',
  backgroundColor: '#fff',
  '&:hover': { backgroundColor: '#F5F5F5', border: '1px solid #E0E0E0' },
}

export const ProofButton = ({ label, onClick }: ProofButtonProps) => (
  <Button fullWidth variant='outlined' endIcon={<DescriptionOutlinedIcon />} onClick={onClick} sx={proofButtonStyles}>
    {label}
  </Button>
)
